import { Link } from "react-router-dom";

export const COLUMN = [
    {
        Header: "Name",
        Footer: "Name",
        accessor: "name",
        sticky: "left",
       
    },
    {
        Header: "Email",
        Footer: "Email",
        accessor: "email",
     
     
    },
    {
        Header: "Company",
        Footer: "Company",
        accessor: "companyName",
     
     
    },
    {
        Header: "Contact No.",
        Footer: "Contact No.",
        accessor: "mobile",
     
     
    },
    {
        Header: "is Email Confirmed",
        Footer: "is Email Confirmed",
        accessor: "emailConfirmed",
     
     
    },
    // {
    //     Header: "is Live",
    //     Footer: "is Live",
    //     accessor: "isLive",
     
     
    // },
   

    // {
    //     Header: "Code",
    //     Footer: "Code",
    //     accessor: "code",
     
     
    // },

  
   

    {
        Header: "Start Date",
        Footer: "Start Date",
        accessor: "startDate",
    },

    {
        Header: "Status",
        Footer: "Status",
        accessor: "status",
    },
  
   
];
